import { DatiDepositoDTO } from "./dati-deposito-dto";

export class DatiDepositoGiudiziarioDTO extends DatiDepositoDTO {
	codiceRtsInoltro: string;
	denominazioneRTS: string;
}